module.exports = __webpack_public_path__ + "assets/img/_Novo Show Unit_Bedroom Flexi_RGB_lr.e9dbf667.jpg";